export default __webpack_public_path__ + "static/media/sexual-behavior.f9eff1b6.svg";